import React, { Component } from "react";
export default class NumberLocation extends Component {
  render() {
    var {
      number_location_score,
      number_location_status_1,
      number_location_status_2,
      number_location_status_3,
      number_location_status_4,
    } = this.props.data;
    return (
      <div className="row border border-dark bg-white">
        <div className="col-lg-12">
          <div className="row mt-4">
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                  marginLeft: -6,
                }}
              >
                &nbsp;&nbsp;<b>1)</b>
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="number-location-image"
                  src={"./assets/images/ecas/form-b/number_location/1.png"}
                  alt="scorpion"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                  marginLeft: -6,
                }}
              >
                &nbsp;&nbsp;<b>2) </b>
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="number-location-image"
                  src={"./assets/images/ecas/form-b/number_location/2.png"}
                  alt="scorpion"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                  marginLeft: -6,
                }}
              >
                &nbsp;&nbsp;<b>3) </b>
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="number-location-image"
                  src={"./assets/images/ecas/form-b/number_location/3.png"}
                  alt="scorpion"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                  marginLeft: -6,
                }}
              >
                &nbsp;&nbsp;<b>4) </b> 
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="number-location-image"
                  src={"./assets/images/ecas/form-b/number_location/4.png"}
                  alt="scorpion"
                />
              </div>
            </div>
            <div className="col-lg-6">
              <br />
              <span className="fs-19">Score (0-4) </span>
              <input
                type="number"
                disabled
                name="number_location_score"
                value={number_location_score}
                className="ecas-input-field"
                placeholder="Score"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
